'use strict';

Object.defineProperty(exports, "__esModule", { value: true });
exports.Wallet = void 0;
var transport_1 = require("../../transport");
var Wallet = /** @class */ (function () {
    function Wallet() {
    }
    Wallet.prototype.getGamingAccounts = function () {
        return transport_1.transport.request('wallet/getGamingAccounts');
    };
    Wallet.prototype.getGamingCoreXAccounts = function () {
        return transport_1.transport.request('corex/get-user-wallets');
    };
    Wallet.prototype.getApplicableBonuses = function () {
        return transport_1.transport.request('wallet/getApplicableBonuses');
    };
    Wallet.prototype.forfeitBonus = function (params) {
        return transport_1.transport.request('wallet/forfeitBonus', params);
    };
    Wallet.prototype.getDepositRemainingLimits = function () {
        return transport_1.transport.request('wallet/getDepositRemainingLimits');
    };
    Wallet.prototype.getTransactionHistory = function (params) {
        return transport_1.transport.request('wallet/getTransactionHistoryV2', params);
    };
    Wallet.prototype.getGrantedBonuses = function () {
        return transport_1.transport.request('wallet/getGrantedBonuses');
    };
    Wallet.prototype.getGamesTransactions = function (params) {
        return transport_1.transport.request('wallet/getGamesTransactions', params);
    };
    Wallet.prototype.getBettingHistoryTotalNetWins = function (params) {
        return transport_1.transport.request('wallet/getBettingHistoryTotalNetWins', params);
    };
    Wallet.prototype.getBettingHistory = function (params) {
        return transport_1.transport.request('wallet/getBettingHistory', params);
    };
    Wallet.prototype.getBonusesHistory = function (params) {
        return transport_1.transport.request('wallet/getBonusesHistory', params);
    };
    Wallet.prototype.getLifetimeDeposits = function () {
        return transport_1.transport.request('wallet/getLifetimeDeposits');
    };
    Wallet.prototype.redeemSweepCoins = function (amount) {
        return transport_1.transport.request('corex/redeem-sweepcoins', { amount: amount });
    };
    Wallet.prototype.getGalleonPaymentMethods = function () {
        return transport_1.transport.request('cashier/fetch-payment-methods');
    };
    return Wallet;
}());
exports.Wallet = Wallet;
